// Save as src/data/events.js  (shared by the events list and the event page)
import coverBeforeWeGetOlder from "../assets/beforewegetolderCover.png";
import coverInBetween from "../assets/theinbetweencover.jpg";
import { API_URL, LOCAL_API_URL } from "../config/api";

// The address of your events page in App.js. Event pages live under it,
// for example /book-events/sila-2026
export const EVENTS_PATH = "/book-events";

/* ============================================================
   YOUR EVENTS: this is the only part you edit
   status: "hidden"   -> not shown anywhere
           "upcoming" -> card on the events page, full page
           "past"     -> moves to "Past events"; its page shows the photos
   type: "fair"       -> uses the fair layout (no reservation form)
   registrationOpen: false -> no reservation form
   covers: up to 2 book covers shown in the page header
   ============================================================ */
export const EVENTS = [
  {
    id: "sila-2026",
    type: "fair",
    status: "upcoming",
    registrationOpen: false,
    name: "Sila Book Fair",
    tagline: "Come meet the book, and the person behind them.",
    date: "29 October – 7 November 2026",
    time: "10:00 AM – 8:00 PM, daily",
    venue: "Sila International Book Fair",
    area: "Algiers",
    mapUrl: "", // paste your Google Maps link when you have it
    entry: "Free",
    cardNote: "Walk in, no reservation needed",
    covers: [
      { src: coverInBetween, alt: "Cover of The In Between" },
    ],
    fair: {
      hall: "جناح فلسطين",
      stand: "C111",
      bookUrl: "", // your book page route, e.g. "/the-in-between?from=fair" (empty = button hidden)
      signing: {
        day: "Sunday 1 November",
        time: "1:00 – 3:00 PM",
      },
      activities: [
        {
          title: "Your gift: journaling cards",
          text: "Journaling cards for each chapter: healing the soul, the mind, the body and trauma, plus some candies.",
          // after you take the photo: import it at the top of this file, e.g.
          // import journalingCards from "../assets/events/journaling-cards.jpg";
          // then set image: journalingCards  (empty "" = shows a placeholder)
          image: "",
          imageAlt: "The gift journaling cards and candies",
        },
        {
          title: "A line to the person you were",
          text: "On 1 November, write one line to the person you were a year ago and pin it to the board.",
        },
      ],
      // after Thursday: import your photos and add them here
      // import poster1 from "../assets/events/poster-1.jpg";
      gallery: [], // [{ src: poster1, alt: "The gift set poster" }]
    },
    recap: "",
    photos: [],
  },

  {
    id: "evening-of-stories-2026",
    status: "hidden", // switch back to "upcoming" after the fair
    registrationOpen: true,
    name: "An Evening of Stories",
    tagline: "Between who you were and who you're becoming.",
    date: "Friday 25 December 2026",
    time: "4:00 – 6:00 PM",
    venue: "Riwaya Coffee",
    area: "",
    mapUrl: "https://maps.app.goo.gl/8tLp9r2WZuGna9aL9",
    limit: 30,
    maxPerBooking: 3,
    covers: [
      { src: coverBeforeWeGetOlder, alt: "Cover of Before We Get Older" },
      { src: coverInBetween, alt: "Cover of The In Between" },
    ],
    programme: [
      { time: "4:00", title: "Starters", text: "Arrival, drinks, the books and the message wall" },
      { time: "4:30", title: "Opening", text: "A short film to set the mood" },
      { time: "4:40", title: "Main course", text: "The talk, with animated visuals" },
      { time: "5:00", title: "Sides", text: "Guest authors" },
      { time: "5:20", title: "Conversation", text: "A reading and your questions" },
      { time: "5:35", title: "The draw", text: "Raffle and thank-yous" },
      { time: "5:45", title: "Dessert", text: "Signing, photos and mingling" },
    ],
    note: "Entry is free. The café menu is available on site, and every guest can join the raffle for a signed book.",
    recap: "",
    photos: [],
  },
];

/* ============================================================
   BACKEND CALLS (FastAPI)
   ============================================================ */
const BASE = String(
  process.env.NODE_ENV === "development" ? LOCAL_API_URL : API_URL
).replace(/\/$/, "");

export async function getSeats(event) {
  const res = await fetch(`${BASE}/events/${event.id}/seats`);
  if (!res.ok) throw new Error("seats failed");
  return res.json(); // { limit, taken }
}

export async function reserveSeat(event, payload) {
  const res = await fetch(`${BASE}/events/${event.id}/reserve`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("reserve failed");
  return res.json(); // { ok, reason?, left, code? }
}